import actionTypes from './actionTypes';
import { action, generateErrorAction } from '../actions';
import API from '../../apis';
import { store } from '../configureStore';

export const getRegionsList = (id, query) => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.regions
      .getRegionsList(id, query)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.GET_REGIONS_LIST_FAILED,
            reject: actionTypes.GET_REGIONS_LIST_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.GET_REGIONS_LIST_LOADING);
  const success = res => action(actionTypes.GET_REGIONS_LIST_SUCCESS, res);

  return request();
};

export const getAllRegionsNames = data => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.regions
      .getAllRegionsNames(data)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.GET_REGIONS_NAMES_FAILED,
            reject: actionTypes.GET_REGIONS_NAMES_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.GET_REGIONS_NAMES_LOADING);
  const success = res => action(actionTypes.GET_REGIONS_NAMES_SUCCESS, res);

  return request();
};

export const getRegionById = (id) => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.regions
      .getRegionById(id)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.GET_REGION_BY_ID_FAILED,
            reject: actionTypes.GET_REGION_BY_ID_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.GET_REGION_BY_ID_LOADING);
  const success = res => action(actionTypes.GET_REGION_BY_ID_SUCCESS, res);

  return request();
};

export const updateRegion = (reqObject, id) => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.regions
      .updateRegion(reqObject, id)
      .then(() => {
        const { regionsList } = store.getState().regionsReducer;
        const index = regionsList.findIndex(item => item.id === id);
        const updateList = [...regionsList];
        updateList[index] = { id: id, ...reqObject };
        dispatch(success(updateList));
      })
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.UPDATE_REGION_FAILED,
            reject: actionTypes.UPDATE_REGION_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.UPDATE_REGION_LOADING);
  const success = res => action(actionTypes.UPDATE_REGION_SUCCESS, res);

  return request();
};

export const addNewRegion = (reqObject) => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.regions
      .addNewRegion(reqObject)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.ADD_NEW_REGION_FAILED,
            reject: actionTypes.ADD_NEW_REGION_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.ADD_NEW_REGION_LOADING);
  const success = res => action(actionTypes.ADD_NEW_REGION_SUCCESS, res);

  return request();
};